import update from "immutability-helper";
import moment from "moment";
import React from "react";
import { Modal } from "../../../components";
import { validateSegment } from "../../flightvalidator";
import { type CommercialFlightEditProps, type PrivateFlightEditProps, type Segment } from "../../model";
import SegmentEdit from "../segmentedit/segmentedit";

interface Props {
  flight: server.dto.Flight
  editedSegment: server.dto.FlightSegment
  frequentFlyerPrograms: server.dto.FrequentFlyerProgram[]

  onSave: (newFlight: server.dto.Flight) => void
  onModalClose: () => void
}

interface State {
  showFlightlookup: boolean
  editedSegment: CommercialFlightEditProps & PrivateFlightEditProps
  type: server.dto.FlightTypes

  noDepartureAirportError: boolean
  noArrivalAirportError: boolean
  noAirlineError: boolean
  noFlightCodeError: boolean
  noFlightNumberError: boolean
  departureTooEarly: boolean
}

export default class SegmentEditPage extends React.Component<Props, State> {
  state: State = {
    showFlightlookup: false,
    editedSegment: {
      arrival: moment.utc(this.props.editedSegment.arrival.dateTimeLocal),
      departure: moment.utc(this.props.editedSegment.departure.dateTimeLocal),
      arrivalAirport: this.props.editedSegment.arrival.airport,
      departureAirport: this.props.editedSegment.departure.airport,
      arrivalTerminal: this.props.editedSegment.arrival.terminal || "",
      departureTerminal: this.props.editedSegment.departure.terminal || "",
      arrivalGate: this.props.editedSegment.arrival.gate || "",
      departureGate: this.props.editedSegment.departure.gate || "",

      airline: this.props.editedSegment.airline,
      flightCode: this.props.editedSegment.flightDesignator.code || "",
      flightNumber: (this.props.editedSegment.flightDesignator.number + "") || "",
      aircraft: this.props.editedSegment.aircraft || "",
      seats: this.props.editedSegment.seats || "",
      travelClass: this.props.editedSegment.travelClass,
      eticket: this.props.editedSegment.eTicket || "",

      access: this.props.editedSegment.access || "",
      confirmationNumber: this.props.editedSegment.confirmationNumber || "",
      capacity: this.props.editedSegment.capacity.value ? this.props.editedSegment.capacity.value.toString() : "",
      frequentFlyer: this.props.editedSegment.frequentFlyerProgram
    },
    type: this.props.editedSegment.type,
    noDepartureAirportError: false,
    noArrivalAirportError: false,
    noAirlineError: false,
    noFlightCodeError: false,
    noFlightNumberError: false,
    departureTooEarly: false
  };

  validate = (): boolean => {
    const segment: Segment = {
      props: this.state.editedSegment,
      type: this.state.type,
      noDepartureAirportError: this.state.noDepartureAirportError,
      noArrivalAirportError: this.state.noArrivalAirportError,
      noAirlineError: this.state.noAirlineError,
      noFlightCodeError: this.state.noFlightCodeError,
      noFlightNumberError: this.state.noFlightNumberError,
      departureTooEarly: this.state.departureTooEarly
    };
    const validationResult = validateSegment(segment);

    this.setState({
      ...validationResult.errors
    });

    return validationResult.anyErrors();
  };

  onSave = async () => {
    const { editedSegment } = this.state;

    if (this.validate()) {
      return;
    }

    const updatedSegment = update(this.props.editedSegment, {
      arrival: {
        dateTimeLocal: { $set: editedSegment.arrival.toDate() },
        airport: { $set: editedSegment.arrivalAirport },
        terminal: { $set: editedSegment.arrivalTerminal },
        gate: { $set: editedSegment.arrivalGate }
      },
      departure: {
        dateTimeLocal: { $set: editedSegment.departure.toDate() },
        airport: { $set: editedSegment.departureAirport },
        terminal: { $set: editedSegment.departureTerminal },
        gate: { $set: editedSegment.departureGate }
      },
      airline: { $set: editedSegment.airline },
      flightDesignator: {
        $set: {
          code: editedSegment.flightCode,
          number: Number(editedSegment.flightNumber)
        }
      },
      flightNumber: { $set: editedSegment.flightNumber },
      aircraft: { $set: editedSegment.aircraft },
      seats: { $set: editedSegment.seats },
      travelClass: { $set: editedSegment.travelClass },
      eTicket: { $set: editedSegment.eticket },
      access: { $set: editedSegment.access },
      confirmationNumber: { $set: editedSegment.confirmationNumber },
      frequentFlyerProgram: { $set: editedSegment.frequentFlyer },
      capacity: {
        $set: {
          value: Number(editedSegment.capacity),
          formatted: ""
        }
      },
      type: { $set: this.state.type }
    });

    const removedSegment = this.props.flight.segments.filter(seg => seg.id !== this.props.editedSegment.id);
    const updatedFlight = update(this.props.flight, {
      segments: { $set: [...removedSegment, updatedSegment] }
    });

    const result = await window.Api.Flights.UpdateFlight(this.props.flight.id, updatedFlight);

    this.props.onSave(result.data);
  };

  public render(): JSX.Element {
    return <>
      <Modal
        title={RESX.Flight.resxFlight}
        isOpen
        width={"large"}
        height={800}
        hasAutoScrollBox
        handleClose={this.props.onModalClose}
      >
        <div className="grow1 scrollbox-auto s1_panel">
          <SegmentEdit
            index={0}
            editedSegment={this.state.editedSegment}
            onSegmentEdited={newSegment => { this.setState({ editedSegment: newSegment }); }}

            type={this.state.type}
            onTypeChanged={type => { this.setState({ type }); }}
            frequentFlyerPrograms={this.props.frequentFlyerPrograms}
            noAirlineError={this.state.noAirlineError}
            noArrivalAirportError={this.state.noArrivalAirportError}
            noDepartureAirportError={this.state.noDepartureAirportError}
            noFlightCodeError={this.state.noFlightCodeError}
            noFlightNumberError={this.state.noFlightNumberError}
            departureTooEarly={this.state.departureTooEarly}
          />
        </div>
        <div className="flex margin-top-large justify-end margin-right">
          <div>
            <button type="button" onClick={this.onSave} className="button-new primary" value={RESX.Buttons.btnSave} name="Save">
              {RESX.Buttons.btnSave}
            </button>
          </div>
        </div>
      </Modal>
    </>;
  }
}
